module.exports = __webpack_public_path__ + "static/img/hddd2.8d559b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/hddd2.png
// module id = 323
// module chunks = 0